const PROTOCOL = 'https';
const TLD = 'com';

export default {
  BASE_URL:
    process.env.NODE_ENV == "production"
      ? PROTOCOL+"://embed.adabundle."+TLD+"/api/v1"
      : PROTOCOL+"://embed.adabundle."+TLD+"/api/v1",
  EMBED_URL:
    process.env.NODE_ENV == "production"
      ? PROTOCOL+"://embed.adabundle."+TLD+"/"
      : PROTOCOL+"://embed.adabundle."+TLD+"/",
  CONTENT_TYPE: "application/json;",
  RESPONSE_201_ERROR: "[201] We could not complete your request at the moment",
  RESPONSE_200_ERROR: "[200] We could not complete your request at the moment",
  RESPONSE_ERROR:
    "We could not complete your request at the moment, Please try again later.",
  NETWORK_ERROR:
    "Connection Lost, please check your internet connection and try again.",

  DEFAULT_LANGUAGE: "english",
};
